import { useState, useEffect } from 'react';
import { useMediaViewerListener } from './useMediaViewerListener';
import { useIframeVisibleHeight } from './useIframeVisibleHeight';

const MESSAGE_TYPE = 'contentSize';

export const useContentSize = (
	uniqueKey?: string,
): {
	height: number;
} => {
	// The initial height is arbitrarily set to 1000
	const [height, setHeight] = useState(1000);

	/* This visible height refers to the portion of the confluence page that is visible within the iframe without having to scroll.
		When isHeightSetFromContent is true, the embedded page container height toggles between the visible height and the content height
		depending on whether media viewer is open or close.
		This updated was added as a resolution to the bug explained in this ticket: https://hello.jira.atlassian.cloud/browse/CBT-3636
	*/
	const { isMediaOpen } = useMediaViewerListener();
	const { visibleHeight } = useIframeVisibleHeight(uniqueKey);

	useEffect(() => {
		const contentSizeHandler = (postMessage: MessageEvent) => {
			const data = postMessage.data;
			if (
				data?.type === MESSAGE_TYPE &&
				data?.height &&
				// If uniqueKey is provided, check if the message is for the correct uniqueKey; if uniqueKey is undefined, fallback to existing logic to accept all messages
				(uniqueKey ? data?.uniqueKey === uniqueKey : true)
			) {
				setHeight(data.height);
			}
		};

		window.addEventListener('message', contentSizeHandler);

		return () => {
			window.removeEventListener('message', contentSizeHandler);
		};
	}, [uniqueKey]);

	return { height: isMediaOpen ? visibleHeight : height };
};
